import Circle from "./Circle";
import IconCheck from "ui/icons/IconCheck";
import IconClose from "ui/icons/IconClose";

## Basic Usage

<Circle size={40} bg="sapphireLight" />

---

## Sizes

<div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
  <Circle size={20} bg="stone" />
  <Circle size={30} bg="stone" />
  <Circle size={40} bg="stone" />
  <Circle size={50} bg="stone" />
  <Circle size={60} bg="stone" />
</div>

---

## Background Colors

<div style={{ display: "flex", alignItems: "center", gap: "0.5rem", flexWrap: "wrap" }}>
  <Circle size={40} bg="sapphireLight" />
  <Circle size={40} bg="emeraldLight" />
  <Circle size={40} bg="rubyLight" />
  <Circle size={40} bg="amberLight" />
  <Circle size={40} bg="stone" />
  <Circle size={40} bg="transparent" style={{ border: "1px solid #ccc" }} />
</div>

---

## With Content

<div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
  <Circle size={40} bg="emeraldLight">
    <IconCheck size={20} color="emerald" />
  </Circle>
  <Circle size={40} bg="rubyLight">
    <IconClose size={20} color="ruby" />
  </Circle>
  <Circle size={40} bg="sapphireLight">
    <span style={{ fontSize: "14px", fontWeight: "bold", color: "#3b82f6" }}>AB</span>
  </Circle>
  <Circle size={40} bg="amberLight">
    <span style={{ fontSize: "16px" }}>1</span>
  </Circle>
</div>

---

## Rounded Corners Variant

The `corners` prop adds slight rounding instead of a perfect circle:

<div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
  <Circle size={40} bg="sapphireLight">
    <span>A</span>
  </Circle>
  <Circle size={40} bg="sapphireLight" corners>
    <span>A</span>
  </Circle>
</div>

<p style={{ marginTop: "0.5rem" }}>Left: default circle, Right: with corners</p>

---

## Avatar Example

<div style={{ display: "flex", alignItems: "center", gap: "0.75rem" }}>
  <Circle size={36} bg="sapphireLight">
    <span style={{ fontSize: "14px", fontWeight: 500 }}>JD</span>
  </Circle>
  <div>
    <div style={{ fontWeight: 500 }}>John Doe</div>
    <div style={{ fontSize: "12px", color: "#666" }}>john@example.com</div>
  </div>
</div>


